import * as React from 'react';

import { getMapYears } from '../../../../utils/map';
import { Year } from '../Year/Year';
import * as styles from './Years.css';

interface IYearProps {
  selectedYear: number;
  nextAvailableYear: number | null;
  onChange: (value: number) => void;
  isFullscreen: boolean;
}

export const Years: React.VFC<IYearProps> = ({ selectedYear, onChange, nextAvailableYear, isFullscreen }) => {
  const mapYears = getMapYears();

  return (
    <div className={styles['base']} data-testid="MapYears">
      {mapYears.map(year => (
        <Year
          key={year}
          year={year}
          onChange={onChange}
          checked={year === selectedYear}
          nextAvailableYear={nextAvailableYear}
          isFullscreen={isFullscreen}
        />
      ))}
    </div>
  );
};
